//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import angular from 'angular';

import template from '@legacy-components/nav3/creators-menu.html';

angular.module('curalate').component('creatorsMenu', {
  template,
});
